// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2R1D4","text":"SelectPayment_text__2JilD","title":"SelectPayment_title__2dXKh","btn":"SelectPayment_btn__HvfAS"};